import React from "react";
import TopNavbar from "../Nav/TopNavbar";
import "../Contact/contactus.css";

import Services from "./Services";

function ContactUs() {
  return (
    <>
      <TopNavbar />
      <Services />
    </>
  );
}

export default ContactUs;
